// app/frontend/src/data/avatarCatalogV2.js
// Avatar Catalog - Upload Only System

// Empty catalog - users upload their own images
export const avatarCatalog = [];

// Get catalog for UI (returns empty packs)
export const getCatalogWithStatusV2 = (user) => {
  return {
    packs: []
  };
};

// Helper function to get avatar by ID (for backward compatibility)
export const getAvatarById = (id) => {
  return null;
};

// Legacy function for backward compatibility
export const is3DPackUnlocked = (user) => {
  return false;
};

// Legacy exports for backward compatibility
export const AVATAR_CATALOG_V2 = avatarCatalog;

